import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import { implementsFunction, isArrayLike, isIterable } from "@thi.ng/checks";
import { illegalArity } from "@thi.ng/errors";
import { isReduced, unreduced } from "./reduced";

var parseArgs = function parseArgs(args) {
  return args.length === 2 ? [undefined, args[1]] : args.length === 3 ? [args[1], args[2]] : illegalArity(args.length);
};

export function reduce() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var rfn = args[0];
  var init = rfn[0];
  var complete = rfn[1];
  var reduce = rfn[2];
  args = parseArgs(args);
  var acc = args[0] == null ? init() : args[0];
  var xs = args[1];
  return unreduced(complete(implementsFunction(xs, "$reduce") ? xs.$reduce(reduce, acc) : isArrayLike(xs) ? reduceArray(reduce, acc, xs) : reduceIterable(reduce, acc, xs)));
}

var reduceArray = function reduceArray(rfn, acc, xs) {
  for (var i = 0, n = xs.length; i < n; i++) {
    acc = rfn(acc, xs[i]);

    if (isReduced(acc)) {
      acc = acc.deref();
      break;
    }
  }

  return acc;
};

var reduceIterable = function reduceIterable(rfn, acc, xs) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = xs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var x = _step.value;
      acc = rfn(acc, x);

      if (isReduced(acc)) {
        acc = acc.deref();
        break;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return acc;
};
/**
 * Convenience helper for building a full `Reducer` using the identity
 * function (i.e. `(x) => x`) as completion step (true for 90% of all
 * bundled transducers).
 *
 * @param init init step of reducer
 * @param rfn reduction step of reducer
 */


export var reducer = function reducer(init, rfn) {
  return [init, function (acc) {
    return acc;
  }, rfn];
};
export var $$reduce = function $$reduce(rfn, args) {
  var n = args.length - 1;
  return isIterable(args[n]) ? args.length > 1 ? reduce(rfn.apply(null, args.slice(0, n)), args[n]) : reduce(rfn(), args[0]) : undefined;
};